import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { PreciosOrdenesFisicasService } from 'src/app/services/empresa/precios-ordenes-fisicas.service';
import { TipoPreciosService } from 'src/app/services/empresa/tipo-precios.service';

@Component({
    selector: 'app-ordenes-fisicas-precios',
    templateUrl: './ordenes-fisicas-precios.component.html',
    styleUrls: ['./ordenes-fisicas-precios.component.scss'],
    standalone: false
})
export class OrdenesFisicasPreciosComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  isDtInitialized = false;

  public precios: any[] = [];
  public tipoPrecios: any[] = [];
  public cargando = false;
  public guardando = false;

  public nuevoValor = '';
  public nuevoTipoPrecio = '';

  public editarValor = '';
  public editarTipoPrecio = '';
  public idValorEditar = '';

  constructor(
    private preciosOrdenesFisicasService: PreciosOrdenesFisicasService,
    private tipoPreciosService: TipoPreciosService,
    private modalService: NgbModal,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      order: [[0, 'desc']],
      language: LanguageApp.spanish_datatables
    };

    this.obtenerTipoPrecios();
    this.obtenerPrecios();
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  obtenerTipoPrecios() {
    this.tipoPreciosService.listarTipoPrecios(localStorage.getItem('token') || '').subscribe((resp: any) => {
      this.tipoPrecios = Array.isArray(resp) ? resp : resp?.rows ?? resp?.data ?? [];
    });
  }

  obtenerPrecios() {
    this.cargando = true;

    this.preciosOrdenesFisicasService.listarPrecios(localStorage.getItem('token') || '').subscribe((resp: any) => {
      const data = Array.isArray(resp) ? resp : resp?.rows ?? resp?.data ?? [];
      this.precios = data;
      this.cargando = false;

      if (!this.isDtInitialized) {
        this.dtTrigger.next(null);
        this.isDtInitialized = true;
        return;
      }

      this.rerender();
    });
  }

  abrirModalAgregar(modal: any) {
    this.nuevoValor = '';
    this.nuevoTipoPrecio = '';
    this.modalService.open(modal, { centered: true });
  }

  abrirModalEditar(modal: any, precio: any) {
    this.idValorEditar = String(precio.COD_PREC ?? '');
    this.editarValor = String(precio.VAL_PREC ?? '');
    this.editarTipoPrecio = String(precio.COD_TIPPREC ?? precio.FK_COD_TIPPREC ?? '');
    this.modalService.open(modal, { centered: true });
  }

  crearPrecio() {
    if (!this.nuevoValor || Number(this.nuevoValor) < 0) {
      this.toastr.error('Ingrese un valor válido.', 'Atención', {
        timeOut: 3000,
        closeButton: true,
        progressBar: true
      });
      return;
    }

    if (!this.nuevoTipoPrecio) {
      this.toastr.error('Seleccione un tipo de precio.', 'Atención', {
        timeOut: 3000,
        closeButton: true,
        progressBar: true
      });
      return;
    }

    this.guardando = true;
    this.preciosOrdenesFisicasService.crearPrecio(this.nuevoValor, this.nuevoTipoPrecio).subscribe({
      next: () => {
        this.guardando = false;
        this.toastr.success('Precio guardado correctamente.', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
        this.modalService.dismissAll();
        this.obtenerPrecios();
      },
      error: () => {
        this.guardando = false;
        this.toastr.error('No se pudo guardar el precio.', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
      }
    });
  }

  actualizarPrecio() {
    if (!this.editarValor || Number(this.editarValor) < 0) {
      this.toastr.error('Ingrese un valor válido.', 'Atención', {
        timeOut: 3000,
        closeButton: true,
        progressBar: true
      });
      return;
    }

    if (!this.editarTipoPrecio) {
      this.toastr.error('Seleccione un tipo de precio.', 'Atención', {
        timeOut: 3000,
        closeButton: true,
        progressBar: true
      });
      return;
    }

    this.guardando = true;
    this.preciosOrdenesFisicasService.editarPrecio(this.idValorEditar, this.editarValor, this.editarTipoPrecio).subscribe({
      next: () => {
        this.guardando = false;
        this.toastr.success('Precio actualizado correctamente.', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
        this.modalService.dismissAll();
        this.obtenerPrecios();
      },
      error: () => {
        this.guardando = false;
        this.toastr.error('No se pudo actualizar el precio.', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
      }
    });
  }

  eliminarPrecio(precio: any) {
    const idPrecio = String(precio.COD_PREC ?? '');
    const valor = String(precio.VAL_PREC ?? 'este registro');

    Swal.fire({
      icon: 'warning',
      title: '¿Eliminar precio?',
      text: `Se eliminará el valor ${valor}.`,
      showCancelButton: true,
      confirmButtonColor: '#6259ca',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (!result.isConfirmed) {
        return;
      }

      this.preciosOrdenesFisicasService.eliminarPrecio(idPrecio).subscribe({
        next: () => {
          this.toastr.success('Precio eliminado correctamente.', 'Atención', {
            timeOut: 3000,
            closeButton: true,
            progressBar: true
          });
          this.obtenerPrecios();
        },
        error: () => {
          this.toastr.error('No se pudo eliminar el precio.', 'Atención', {
            timeOut: 3000,
            closeButton: true,
            progressBar: true
          });
        }
      });
    });
  }

  private rerender(): void {
    if (!this.dtElement) {
      return;
    }

    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }
}

export class LanguageApp {
  public static spanish_datatables = {
    processing: 'Procesando...',
    search: 'Buscar:',
    lengthMenu: 'Mostrar _MENU_ registros',
    info: 'Mostrando desde _START_ al _END_ de _TOTAL_ elementos',
    infoEmpty: 'Mostrando ningún elemento.',
    infoFiltered: '(filtrado _MAX_ elementos total)',
    infoPostFix: '',
    loadingRecords: 'Cargando registros...',
    zeroRecords: 'No se encontraron registros',
    emptyTable: 'No hay datos disponibles en la tabla',
    paginate: {
      first: 'Primero',
      previous: 'Ant',
      next: 'Sig',
      last: 'Último'
    },
    aria: {
      sortAscending: ': Activar para ordenar la tabla en orden ascendente',
      sortDescending: ': Activar para ordenar la tabla en orden descendente'
    }
  };
}
